module.exports = __webpack_public_path__ + "static/img/68081AF_1_R_20200315_LC.d89c0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/68081AF_1_R_20200315_LC.png
// module id = rpnA
// module chunks = 0